export default __webpack_public_path__ + "static/media/907.38d0a97e.gif";